var Curriculog = Curriculog || {};

Curriculog.EntityRelationships = (function ($, _, Backbone, EntityRelationships) {

	EntityRelationships = Curriculog.CurriculogCollection.extend({
		url: '/rest/entityparent',
		model: Curriculog.EntityRelationship,

		findRoots: function () {
			var models = this.filter(function (model) {
				return model.get('entity_parent_id') === null;
			});

			return models.map(function(model){
				return model.get('entity_id');
			});
		},

		getRelationshipsForEntity: function (id) {
			var models = this.filter(function (model) {
				return model.get('entity_id') === id;
			});
			return models;
		},

		findChildren: function (id) {
			var models = this.filter(function (model) {
				return model.get('entity_parent_id') === id;
			});

			return models.map(function (model){
				return model.get('entity_id');
			});
		},

		getDecendants: function (id) {
			var decendants = [];
			this._getDecendants(id, decendants);
			return this._remove_duplicates(decendants);
		},

		_getDecendants: function (id, array) {
			var that = this;
			var immediateChildren = this.findChildren(id);
			immediateChildren.forEach(function (entityID) {
				array.push(entityID);
				that._getDecendants(entityID, array);
			});
		},

		getParents: function (id) {
			var models = this.getRelationshipsForEntity(id);

			parents = []
			models.forEach(function (model) {
				var parentID = model.get('entity_parent_id');

				if (parentID !== null) {
					parents.push(parentID);
				}
			});

			return parents;
		},

		getAncestors: function (id) {
			var ancestors = [];
			this._getAncestors(id, ancestors);
			return this._remove_duplicates(ancestors);
		},

		_getAncestors: function (id, array) {
			var that = this;
			var immediateParents = this.getParents(id);
			immediateParents.forEach(function (entityID) {
				array.push(entityID);
				that._getAncestors(entityID, array);
			});
		},

		removeAllRelationships: function (id) {
			var models = this.getRelationshipsForEntity(id);
			var relationships = this;

			models.forEach(function (model) {
				model.destroy();
			});
		},

		deleteParent: function (entityID, parentID) {
			var view = this;
			var relationships = this.getRelationshipsForEntity(entityID);

			if (relationships.length > 1) {
				var relationship = view.findWhere({
					entity_id: entityID,
					entity_parent_id: parentID,
				});
				relationship.save({
					delete_record: true,
				}, {
					wait: true,

					success: function () {
						view.remove(relationship);
					},

					error: function () {
						view.growl();
					},
				});
			} else {
				var relationship = relationships[0];
				relationship.save({
					entity_parent_id: null,
				}, {
					wait: true,

					error: function () {
						view.growl();
					},
				});
			}
		},

		_remove_duplicates: function (array) {
			var uniqueValues = [];
			$.each(array, function(i, el){
			    if($.inArray(el, uniqueValues) === -1) uniqueValues.push(el);
			});
			return uniqueValues
		},

		growl: function () {
			var errorText = 'An error was encountered when removing the parent.  ';
			errorText += 'Please try again or contact an administrator.';
			this.showGrowl(errorText);
		},

	});
	return EntityRelationships;

})($, _, Backbone, Curriculog.EntityRelationships || {});
